module.exports = __webpack_public_path__ + "media/_archive/E-1f81b8a6.png";